module.exports = {"350211001":"集美街道","350211002":"侨英街道","350211003":"杏林街道","350211004":"杏滨街道","350211102":"灌口镇","350211103":"后溪镇","350211401":"第二农场","350211402":"省天马种猪场","350211403":"天马华侨农场","350211404":"坂头防护林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350211.json
// module id = 1286
// module chunks = 0